import React from 'react';
import {CheckoutControllerProps} from '../../../types/checkoutApp.types';
import {useEnvironment, WidgetProps} from '@wix/yoshi-flow-editor';

type VoidReturn<T> = T extends (...args: infer P) => unknown ? (...args: P) => void : T;
type VoidMethodsDeep<T extends Record<string, unknown>> = {
  [K in keyof T]: T[K] extends Record<string, unknown> ? VoidMethodsDeep<T[K]> : VoidReturn<T[K]>;
};
export type UseControllerPropsResult = WidgetProps<VoidMethodsDeep<CheckoutControllerProps>>;

const Context = React.createContext({} as WidgetProps<CheckoutControllerProps>);

export function useControllerProps(): UseControllerPropsResult {
  return React.useContext(Context);
}

export function ControllerContext({
  value,
  children,
}: {
  value: WidgetProps<CheckoutControllerProps>;
  children: React.ReactNode;
}) {
  const {isMobile} = useEnvironment();

  return <Context.Provider value={{...value, isOneColumnView: isMobile}}>{children}</Context.Provider>;
}
